import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { useLocation, useParams } from 'react-router';

interface StableParams {
  projectShortName?: string;
  calculationId?: string;
  templateId?: string;
  asoRequestId?: number;
  asoScenarioId?: number;
  entityListId?: string;
  scopeId?: string;
  slug?: string;
  subpage?: string;
  pickingResultsPart?: string;
}

const stableParamsContext = createContext<StableParams>({});

export function useStableParams(): StableParams {
  return useContext(stableParamsContext);
}

export const StableParamsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const params = useParams();

  const paramsStable = useMemo(
    () => ({
      projectShortName: params.projectShortName,
      calculationId: params.calculationId,
      templateId: params.templateId,
      entityListId: params.entityListId,
      scopeId: params.scopeId,
      slug: params.slug,
      subpage: params.subpage,
      pickingResultsPart: params.pickingResultsPart,
      asoRequestId: params.asoRequestId ? parseInt(params.asoRequestId) : undefined,
      asoScenarioId: params.asoScenarioId ? parseInt(params.asoScenarioId) : undefined,
    }),
    [
      params.projectShortName,
      params.calculationId,
      params.templateId,
      params.entityListId,
      params.scopeId,
      params.slug,
      params.subpage,
      params.pickingResultsPart,
      params.asoRequestId,
      params.asoScenarioId,
    ],
  );

  return (
    <stableParamsContext.Provider value={paramsStable}>{children}</stableParamsContext.Provider>
  );
};

interface StableSearch {
  search: string;
}

const stableSearchContext = createContext<StableSearch>({ search: '' });

export function useStableSearch(): StableSearch {
  return useContext(stableSearchContext);
}

export const StableSearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();

  const stableSearch = useMemo(
    () => ({
      search: location.search,
    }),
    [location.search],
  );

  return (
    <stableSearchContext.Provider value={stableSearch}>{children}</stableSearchContext.Provider>
  );
};
